/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/style-prop-object */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/no-array-index-key */
import { useState } from 'react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import { State } from 'redux/initialState';

import { dateFormat } from 'constants/formats';
import ToggleWidthButton from 'modules/_shared/components/Buttons/ToggleWidthButton';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import OperationMenuDots from 'modules/_shared/components/MenuDots/OperationMenuDots';
import InfoMessage from 'modules/_shared/components/InfoMessage';

import { useTranslate } from 'hooks/useTranslate';

import PlanSummaryBeneficiaryMainTable from './components/PlanSummaryBeneficiaryMainTable';
import PlanSummaryBeneficiaryPeriodsTable from './components/PlanSummaryBeneficiaryPeriodsTable';
import PlanSummaryMainTable from './components/PlanSummaryMainTable';
import PlanSummaryPeriodsTable from './components/PlanSummaryPeriodsTable';
import { usePlanSummary } from './hooks/usePlanSummary';

import './PlanSummary.scss';

const PlanSummary = () => {
  const { t, i18n } = useTranslate();
  const [isTodaySummaryVisible, setIsTodaySummaryVisible] = useState(true);

  const isAdmin = useSelector((state: State) => state.society?.role?.isAdmin);
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  const { data, actions, isLoading } = usePlanSummary(i18n);

  const {
    view,
    mode,
    showValuesFormatted,
    endDate,
    summary,
    todaySummary,
    plansNames,
    values,
    periods,
    beneficiariesSummary,
    beneficiariesNames,
    beneficiariesEmails,
    beneficiariesCifs,
    beneficiariesStrikePrices,
    beneficiariesCancelationDates,
    beneficiariesValues,
    beneficiariesPeriods,
    currentViewOptions,
    currentModeOptions,
  } = data;

  const {
    setView,
    setMode,
    setShowValuesFormatted,
    setEndDate,
    handleExportTable,
  } = actions;

  return (
    <>
      <div
        id="plan-summary-container"
        className="nk-content-body mr-0 mt-4"
        style={{ width: 'calc(100%)' }}
      >
        <div className="nk-content-wrap w-100">
          <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
              <div className="nk-block-head-content">
                <h3 className="nk-block-title page-title">
                  {mode === 0 ? t('PlansSummary') : t('BeneficiariesSummary')}
                </h3>
              </div>
              <div className="nk-block-head-content">
                <div className="toggle-wrap nk-block-tools-toggle">
                  <a
                    className="btn btn-icon btn-trigger toggle-expand mr-n1"
                    data-target="pageMenu"
                    aria-label="link"
                  >
                    <em className="icon ni ni-menu-alt-r" />
                  </a>
                  <div
                    className="toggle-expand-content"
                    data-content="pageMenu"
                  >
                    <ul className="nk-block-tools g-3">
                      {isAdmin && (
                        <li>
                          <ReactHTMLTableToExcel
                            id="plansPeriodsBtn"
                            className="d-none"
                            table="periodsTable"
                            filename={`${t('PlansSummary')} - ${
                              actualSociety?.name
                            }`}
                            sheet="Resumen Planes Incentivos"
                            buttonText={`${t('Download')}`}
                            buttonComponent={
                              // eslint-disable-next-line react/jsx-wrap-multilines
                              <button
                                type="button"
                                className="btn btn-white btn-outline-light"
                              >
                                <em className="icon ni ni-file-download" />
                              </button>
                            }
                          />
                          <ReactHTMLTableToExcel
                            id="plansSummaryBtn"
                            className="d-none"
                            table="summaryTable"
                            filename={`${t('PlansSummary')} - ${
                              actualSociety?.name
                            }`}
                            sheet="Resumen Planes Incentivos"
                            buttonText={`${t('Download')}`}
                            buttonComponent={
                              // eslint-disable-next-line react/jsx-wrap-multilines
                              <button
                                type="button"
                                className="btn btn-white btn-outline-light"
                              >
                                <em className="icon ni ni-file-download" />
                              </button>
                            }
                          />

                          <ReactHTMLTableToExcel
                            id="beneficiariesPeriodsBtn"
                            className="d-none"
                            table="beneficiaryPeriodsTable"
                            filename={`${t('BeneficiariesSummary')} - ${
                              actualSociety?.name
                            }`}
                            sheet="Resumen Beneficiarios"
                            buttonText={`${t('Download')}`}
                            buttonComponent={
                              // eslint-disable-next-line react/jsx-wrap-multilines
                              <button
                                type="button"
                                className="btn btn-white btn-outline-light"
                              >
                                <em className="icon ni ni-file-download" />
                              </button>
                            }
                          />

                          <ReactHTMLTableToExcel
                            id="beneficiariesSummaryBtn"
                            className="d-none"
                            table="beneficiarySummaryTable"
                            filename={`${t('BeneficiariesSummary')} - ${
                              actualSociety?.name
                            }`}
                            sheet="Resumen Beneficiarios"
                            buttonText={`${t('Download')}`}
                            buttonComponent={
                              // eslint-disable-next-line react/jsx-wrap-multilines
                              <button
                                type="button"
                                className="btn btn-white btn-outline-light"
                              >
                                <em className="icon ni ni-file-download" />
                              </button>
                            }
                          />
                        </li>
                      )}
                      <li className="preview-item">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => handleExportTable(mode, view)}
                        >
                          {t('Download')}
                        </button>
                      </li>
                      <li className="preview-item">
                        {/* @ts-ignore */}
                        <OperationMenuDots
                          title={t('View')}
                          menuOptions={currentModeOptions}
                          params={{
                            setMode,
                          }}
                        />
                      </li>
                      <li className="preview-item">
                        {/* @ts-ignore */}
                        <OperationMenuDots
                          title={t('Historic')}
                          menuOptions={currentViewOptions}
                          params={{
                            setView,
                          }}
                        />
                      </li>
                      {view === 2 && (
                        <li className="preview-item">
                          <div className="form-group">
                            <div className="form-control-wrap">
                              <input
                                type="date"
                                className="form-control date-picker"
                                value={endDate}
                                disabled={view !== 2}
                                onChange={(event) =>
                                  setEndDate(event.target.value)
                                }
                                required
                              />
                            </div>
                          </div>
                        </li>
                      )}

                      <li className="preview-item">
                        <ToggleWidthButton />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mode = 0 => Plans view */}
          {/* Mode = 1 => Beneficiaries view */}
          {/* Mode = 2 => Beneficiaries & Plans view */}

          {/* View = 0 => Quarterly */}
          {/* View = 1 => Yearly */}
          {/* View = 2 => Summary */}

          {mode === 0 && view < 2 && summary && values && periods && (
            <PlanSummaryPeriodsTable
              view={view}
              summary={summary}
              plansNames={plansNames}
              periods={periods}
              values={values}
              isFormatted={showValuesFormatted}
            />
          )}

          {mode === 0 && view === 2 && summary && (
            <PlanSummaryMainTable
              view={view}
              summary={summary}
              todaySummary={todaySummary}
              plansNames={plansNames}
              isFormatted={showValuesFormatted}
              isTodaySummaryVisible={isTodaySummaryVisible}
            />
          )}

          {(mode === 1 || mode === 2) &&
            view < 2 &&
            beneficiariesSummary &&
            beneficiariesValues &&
            beneficiariesPeriods && (
              <PlanSummaryBeneficiaryPeriodsTable
                view={view}
                summary={beneficiariesSummary}
                names={beneficiariesNames}
                periods={beneficiariesPeriods}
                values={beneficiariesValues}
                isFormatted={showValuesFormatted}
              />
            )}

          {(mode === 1 || mode === 2) && view === 2 && beneficiariesSummary && (
            <PlanSummaryBeneficiaryMainTable
              view={view}
              summary={beneficiariesSummary}
              todaySummary={todaySummary}
              names={beneficiariesNames}
              emails={beneficiariesEmails}
              cifs={beneficiariesCifs}
              strikePrices={beneficiariesStrikePrices}
              cancelationDates={beneficiariesCancelationDates}
              isFormatted={showValuesFormatted}
              isTodaySummaryVisible={isTodaySummaryVisible}
              isStrikePriceVisible={mode === 2}
            />
          )}

          <div className="nk-block d-flex justify-content-between ">
            <div className="d-flex flex-column">
              <div className="custom-control custom-control-xs custom-checkbox">
                <input
                  type="checkbox"
                  id="checkbox-toggle"
                  className="custom-control-input"
                  checked={!showValuesFormatted}
                  onChange={() => setShowValuesFormatted(!showValuesFormatted)}
                />
                <label
                  className="custom-control-label"
                  htmlFor="checkbox-toggle"
                >
                  {t('HideNumericalNotation')}

                  <span className="badge badge-dim badge-light ml-2">BETA</span>
                </label>
              </div>

              <div className="custom-control custom-control-xs custom-checkbox mt-2">
                <input
                  type="checkbox"
                  id="checkbox-today-summary"
                  className="custom-control-input"
                  checked={isTodaySummaryVisible}
                  onChange={() =>
                    setIsTodaySummaryVisible(!isTodaySummaryVisible)
                  }
                />
                <label
                  className="custom-control-label"
                  htmlFor="checkbox-today-summary"
                >
                  {t('ShowTodaySummary')}
                </label>
              </div>
            </div>

            <InfoMessage
              message={`${t('CurrentDateValue')} ${format(
                new Date(),
                dateFormat
              )}`}
            />
          </div>
        </div>
      </div>

      {isLoading && <CustomLoading />}
    </>
  );
};

export default PlanSummary;
